/**
 * @param {string} value
 */
export function replaceNumberWithWildcard(value) {
  // This regex matches any sequence of digits (including decimal points and commas) and captures the non-digit characters around it
  let regex = /[\d.,]+/g;

  // Replace the matched numeric part with a wildcard "*"
  return value.replace(regex, "*");
}
